import {
    MANUTENCAO_MODO_TELA,
    MANUTENCAO_AGUARDANDO,
    MANUTENCAO_LISTADO,
    MANUTENCAO_OPCOES
} from './manutencaoActions';

const INITIAL_STATE = {
    modoTela: 'lista',
    registro: {},
    aguardando: false,
    lista: [],
    veiculos: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case MANUTENCAO_MODO_TELA:
            return {
                ...state,
                modoTela: action.payload.modo,
                registro: action.payload.registro || {}
            };
        case MANUTENCAO_AGUARDANDO:
            return { ...state, aguardando: action.payload };
        case MANUTENCAO_LISTADO:
            return { ...state, lista: action.payload || [] };
        case MANUTENCAO_OPCOES:
            return { ...state, ...(action.payload || {}) };
        default:
            return state;
    }
};
